import { render, staticRenderFns } from "./SuppliesWrhousngStatus.vue?vue&type=template&id=83877a78&scoped=true&"
import script from "./SuppliesWrhousngStatus.vue?vue&type=script&lang=js&"
export * from "./SuppliesWrhousngStatus.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesWrhousngStatus.vue?vue&type=style&index=0&id=83877a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83877a78",
  null
  
)

export default component.exports